import { render, staticRenderFns } from "./ChatOperador.vue?vue&type=template&id=63ae7210"
import script from "./ChatOperador.vue?vue&type=script&lang=js"
export * from "./ChatOperador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports